<template>
  <md-card>
    <md-card-content class="x-sync md-scrollbar md-theme-default">
      <PricingHistoryDaySelector v-on="$listeners" />
      <Legend :data="stackedLegend"></Legend>
      <pricing-stacked-bar-chart
        ref="stackedBars"
        scrollable
        :height="340"
        :data="data"
        :options="options"
        v-on:wrapper-init="$emit('wrapper-init', $event)"
      ></pricing-stacked-bar-chart>
    </md-card-content>
  </md-card>
</template>

<script>
import Legend from '../Charts/Legend.vue'
import PricingStackedBarChart from '../Charts/PricingStackedBarChart.vue'
import PricingHistoryDaySelector from './PricingHistoryDaySelector.vue'
import { colors } from '@/components/Charts/colors.js'

export default {
  name: 'pricing-history-card',
  components: {
    Legend,
    PricingStackedBarChart,
    PricingHistoryDaySelector,
  },
  props: {
    data: Object,
    options: Object,
  },
  computed: {
    stackedLegend() {
      return Object.keys(this.data.options).map((option) => {
        return {
          option: option.toLowerCase(),
          label: this.data.options[option].label,
          backgroundColor: colors[option.toLowerCase()],
        }
      })
    },
  },
  methods: {
    updateData(data) {
      setTimeout(() => {
        this.$refs['stackedBars'].updateData(data)
      }, 1000)
    },
  },
}
</script>
